import { render, staticRenderFns } from "./select-plus.vue?vue&type=template&id=61d927a6&"
import script from "./select-plus.vue?vue&type=script&lang=js&"
export * from "./select-plus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports